import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import MyContext from '../../Common/Context/MyContext'
import './Home.scss'
import WorkOverview from './WorkOverview/WorkOverview'


const Home = () => {



   
    




  

  return (

    <div className='home-main'>
   

<WorkOverview/>

{/*
  <CompanyUpdates/>
  */}


    </div>
 
  )
}

export default Home